<template>
  <admin-wrapper
    title-translation-path="navbar.parcelReportSettings"
    :has-buttons="false"
    :disabled="true"
    :moduleEnabler="moduleEnabler"
  />
</template>
<script>
import AdminWrapper from '@/components/AdminWrapper';
export default {
  name: 'ParcelReportSettings',
  components: {
    AdminWrapper,
  },
  computed: {
    moduleEnabler() {
      return {
        name: 'parcel_report_module_enabled',
        translationPath: 'admin.PARCELS_REPORT',
        subtitle: this.$i18n.t('admin.moduleEnablerSubtitle', { suffix: this.$i18n.t('admin.PARCELS_REPORT') }),
      };
    },
  },
};
</script>
